import {
  AudiusSdkWithServices,
  createSdkWithServices,
  Configuration,
  SolanaRelay,
  ArchiverService
} from '@audius/sdk'

import { env } from 'services/env'

import { getAudiusWalletClient } from './auth'

declare global {
  interface Window {
    audiusSdk: AudiusSdkWithServices
  }
}

let inProgress = false
const SDK_LOADED_EVENT_NAME = 'AUDIUS_SDK_LOADED'

export const initSdk = async () => {
  inProgress = true

  // For now, the only solana relay we want to use is on DN 1, so hardcode
  // the selection there.
  const solanaRelay = new SolanaRelay(
    new Configuration({
      basePath: '/solana',
      middleware: [
        {
          pre: async (context) => {
            const endpoint = env.SOLANA_RELAY_ENDPOINT
            const url = `${endpoint}${context.url}`
            return { url, init: context.init }
          }
        }
      ]
    })
  )

  const archiverService = new ArchiverService(
    new Configuration({
      basePath: '/archive',
      middleware: [
        {
          pre: async (context) => {
            const endpoint = env.ARCHIVE_ENDPOINT
            const url = `${endpoint}${context.url}`
            return { url, init: context.init }
          }
        }
      ]
    })
  )

  const audiusWalletClient = await getAudiusWalletClient()

  const audiusSdk = createSdkWithServices({
    appName: env.APP_NAME,
    apiKey: env.API_KEY,
    environment: env.ENVIRONMENT,
    apiEndpoint: env.API_URL,
    services: {
      solanaRelay,
      audiusWalletClient,
      archiverService
    }
  })
  console.debug('[audiusSdk] SDK initted.')
  window.audiusSdk = audiusSdk
  inProgress = false
  window.dispatchEvent(new CustomEvent(SDK_LOADED_EVENT_NAME))
  return audiusSdk
}

export const audiusSdk = async () => {
  if (inProgress) {
    await new Promise((resolve) => {
      window.addEventListener(SDK_LOADED_EVENT_NAME, resolve)
    })
  } else if (!window.audiusSdk) {
    return await initSdk()
  }
  return window.audiusSdk
}
